import React  from 'react';
function AnimalZakatTable({ result }) {
  let camelColSpan;
  if (result.camel.zakatDuty === 'no') {
    camelColSpan = 2;
  } else if (result.camel.operator) {
    camelColSpan = 5;
  } else {
    camelColSpan = 3;
  }
  let cowColSpan;
  if (result.cow.zakatDuty === 'no') {
    cowColSpan = 2;
  } else if (result.cow.operator) {
    cowColSpan = 5;
  } else {
    cowColSpan = 3;
  }
  let sheepColSpan;
  if (result.sheep.zakatDuty === 'no') {
    sheepColSpan = 2;
  } else if (result.sheep.operator) {
    sheepColSpan = 5;
  } else {
    sheepColSpan = 3;
  }
  return (
    <table >
      <thead>
        <tr>
          <th >Animal Category</th>
          <th colSpan={3} className="bmi-header">Results</th>
        </tr>
      </thead>
      <tbody>
                <tr>
          <td rowSpan={camelColSpan}>Camel</td>
        </tr>
        <tr>
          <td colSpan={2}><b>Zakat Obligation</b></td>
          <td>{result.camel.zakatDuty === 'yes' ? 'Zakat is obligatory for you' : 'Zakat is not obligatory for you'}</td>
        </tr>
        {result.camel.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Zakat Value</b></td>
            <td colSpan={2}>{result.camel.zakatAmount_1} - {result.camel.description_ar_1}</td>
          </tr>
        )}
        {result.camel.operator && result.camel.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.camel.operator === 'or' ? 'Or' : 'And'}</td>
          </tr>
        )}
        {result.camel.operator && result.camel.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.camel.zakatAmount_2} - {result.camel.description_ar_2}</td>
          </tr>
        )}
                <tr>
          <td colSpan={4} className="bmi-header"></td>
        </tr>
                <tr>
          <td rowSpan={cowColSpan}>Cows</td>
        </tr>
        <tr>
          <td colSpan={2}><b>Zakat Obligation</b></td>
          <td>{result.cow.zakatDuty === 'yes' ? 'Zakat is obligatory for you' : 'Zakat is not obligatory for you'}</td>
        </tr>
        {result.cow.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Zakat Value</b></td>
            <td colSpan={2}>{result.cow.zakatAmount_1} - {result.cow.description_ar_1}</td>
          </tr>
        )}
        {result.cow.operator && result.cow.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.cow.operator === 'or' ? 'Or' : 'And'}</td>
          </tr>
        )}
        {result.cow.operator && result.cow.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.cow.zakatAmount_2} - {result.cow.description_ar_2}</td>
          </tr>
        )}
                <tr>
          <td colSpan={4} className="bmi-header"></td>
        </tr>
                <tr>
          <td rowSpan={sheepColSpan}>Sheep</td>
        </tr>
        <tr>
          <td colSpan={2}><b>Zakat Obligation</b></td>
          <td>{result.sheep.zakatDuty === 'yes' ? 'Zakat is obligatory for you' : 'Zakat is not obligatory for you'}</td>
        </tr>
        {result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Zakat Value</b></td>
            <td colSpan={2}>{result.sheep.zakatAmount_1} - {result.sheep.description_ar_1}</td>
          </tr>
        )}
        {result.sheep.operator && result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.sheep.operator === 'or' ? 'Or' : 'And'}</td>
          </tr>
        )}
        {result.sheep.operator && result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.sheep.zakatAmount_2} - {result.sheep.description_ar_2}</td>
          </tr>
        )}
                <tr>
          <td colSpan={4} className="bmi-header"></td>
        </tr>
      </tbody>
    </table>
  );
}
export default AnimalZakatTable;
